'use client'

import { createContext, use, JSX } from 'react'

import {
  useWalletConnect,
  WalletConnectControls,
} from '~/hooks/useWalletConnect'

const WalletConnectContext = createContext<WalletConnectControls | undefined>(
  undefined,
)

export function WalletConnectProvider({
  children,
}: {
  children: JSX.Element
}): JSX.Element {
  const walletConnect = useWalletConnect()

  return (
    <WalletConnectContext value={walletConnect}>
      {children}
    </WalletConnectContext>
  )
}

export const useWalletConnectContext: () => WalletConnectControls = () => {
  const context = use(WalletConnectContext)
  if (!context)
    throw new Error(
      'useWalletConnectContext must be within WalletConnectProvider',
    )

  return context
}
